import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const SECTIONS = [
  {
    n: "01",
    title: "Titolare del trattamento",
    body: "Vico's Scooter — Via Glira 4, 39036 San Cassiano in Badia (BZ), Italia. Email: info@vicotravel.it · Telefono: +39 335 6116528. Il Titolare è responsabile del trattamento dei tuoi dati personali ai sensi del Regolamento (UE) 2016/679 (GDPR)."
  },
  {
    n: "02",
    title: "Dati raccolti",
    body: "Raccogliamo: (a) dati anagrafici e di contatto forniti al momento della prenotazione (nome, email, telefono); (b) dati di pagamento gestiti esclusivamente da Stripe (non conserviamo numeri di carta); (c) dati di accesso se crei un account (email, password hashata, o profilo Google); (d) dati tecnici di navigazione (IP, browser, lingua) tramite cookie tecnici essenziali."
  },
  {
    n: "03",
    title: "Finalità del trattamento",
    body: "Trattiamo i tuoi dati esclusivamente per: (1) eseguire il contratto di noleggio (prenotazioni, fatturazione, comunicazioni operative); (2) adempiere obblighi di legge (fatturazione, sicurezza stradale); (3) inviare email di conferma e promemoria pre-ritiro; (4) gestire eventuali sinistri o richieste di assistenza."
  },
  {
    n: "04",
    title: "Base giuridica",
    body: "Il trattamento è basato sull'esecuzione del contratto (art. 6.1.b GDPR) per i dati di prenotazione, su obblighi legali (art. 6.1.c GDPR) per la fatturazione, e sul legittimo interesse del Titolare (art. 6.1.f GDPR) per le comunicazioni operative strettamente necessarie."
  },
  {
    n: "05",
    title: "Conservazione dei dati",
    body: "I dati relativi alle prenotazioni vengono conservati per 10 anni ai sensi della normativa fiscale italiana. I dati di account utente possono essere cancellati in qualsiasi momento contattandoci. I dati di pagamento sono gestiti e conservati da Stripe secondo le sue policy (vedi stripe.com/privacy)."
  },
  {
    n: "06",
    title: "Destinatari dei dati",
    body: "I dati possono essere condivisi con: Stripe Payments Europe Ltd. (processore dei pagamenti), Resend Inc. (invio email transazionali), MongoDB Atlas / hosting provider (archiviazione). Tutti i fornitori operano sotto adeguate garanzie contrattuali e sono conformi al GDPR. Non vendiamo né cediamo dati a terzi per scopi di marketing."
  },
  {
    n: "07",
    title: "I tuoi diritti",
    body: "Hai diritto di: (a) accedere ai tuoi dati; (b) chiederne la rettifica; (c) chiederne la cancellazione (\"diritto all'oblio\"); (d) limitare il trattamento; (e) opporti al trattamento; (f) ottenere la portabilità dei dati. Per esercitare questi diritti scrivici a info@vicotravel.it. Hai inoltre il diritto di reclamo al Garante Privacy (garanteprivacy.it)."
  },
  {
    n: "08",
    title: "Cookie",
    body: "Il sito utilizza esclusivamente cookie tecnici essenziali (sessione di login, preferenza lingua, prevenzione frodi Stripe). Non utilizziamo cookie di profilazione o di terze parti per marketing. Puoi disabilitare i cookie dal tuo browser ma alcune funzionalità (login, pagamento) potrebbero non funzionare correttamente."
  },
  {
    n: "09",
    title: "Trasferimenti extra-UE",
    body: "Alcuni dei nostri fornitori (Stripe, Google per login Google) possono trasferire dati negli Stati Uniti d'America. Tali trasferimenti avvengono solo verso aziende che aderiscono al Data Privacy Framework UE-USA o tramite Standard Contractual Clauses approvate dalla Commissione Europea."
  },
  {
    n: "10",
    title: "Aggiornamenti",
    body: "Questa informativa potrà essere aggiornata in caso di modifiche normative o operative. La versione corrente è sempre disponibile su questa pagina. Versione attuale: 1 settembre 2026."
  },
];

export default function Privacy() {
  return (
    <div className="min-h-screen bg-[#050505] text-white" data-testid="privacy-page">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24">
        <Link to="/" className="inline-flex items-center gap-2 text-xs tracking-[0.3em] uppercase font-bold text-zinc-500 hover:text-scooter-yellow mb-12" data-testid="privacy-back">
          <ArrowLeft className="w-3 h-3" /> Home
        </Link>
        <div className="text-[11px] tracking-[0.35em] uppercase font-bold text-scooter-yellow mb-4">Legale</div>
        <h1 className="font-heading font-black text-5xl sm:text-7xl tracking-tighter leading-[0.9] mb-6">Privacy<br/>Policy</h1>
        <p className="text-zinc-400 mb-12 text-sm">Vico's Scooter · Conforme GDPR · Versione del 1 settembre 2026</p>

        <div className="space-y-12">
          {SECTIONS.map(s => (
            <section key={s.n} className="border-l-2 border-scooter-yellow/40 pl-6" data-testid={`privacy-section-${s.n}`}>
              <div className="font-heading text-stroke text-5xl font-black tracking-tighter mb-2">{s.n}</div>
              <h2 className="font-heading font-bold text-2xl tracking-tight mb-4">{s.title}</h2>
              <p className="text-zinc-300 leading-relaxed">{s.body}</p>
            </section>
          ))}
        </div>

        <div className="mt-16 p-6 border border-amber-500/30 bg-amber-500/5 text-xs text-amber-200/80 leading-relaxed">
          <strong className="text-amber-300">Nota informativa.</strong> Questo documento copre i requisiti base del GDPR. Si raccomanda di farlo revisionare da un consulente privacy/legale prima della messa in produzione per il proprio caso d'uso specifico.
        </div>
      </div>
    </div>
  );
}
